// extracted by mini-css-extract-plugin
var _1 = "SettingsStatus-moduleSettingsStatus__LISfV";
var _2 = "SettingsStatus-moduledivider__zEmbD Divider-moduleDivider__dL3Vg";
var _3 = "SettingsStatus-moduleitem__bNec7";
var _4 = "SettingsStatus-modulevalue__OPZTL";
export { _1 as "SettingsStatus", _2 as "divider", _3 as "item", _4 as "value" }
